// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31Sed","tabsBox":"styles_tabsBox__Yq3mN","createButton":"styles_createButton__1UdJZ"};